import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export default function SkeletonShimmer({ baseColor, highlightColor }) {
  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
      <Skeleton />
    </SkeletonTheme>
  );
}
